import {  
  UPDATE_CONTENT,
} from "./actionTypes";

const searchUrls = [
  { path: "/budget" },
  { path: "/budget/:priceFrom", rewrite: "{priceFrom}-{priceTo}"},
  {
    path: "/budget/:priceFrom-:priceTo",
    rewrite: "{priceFrom}-{priceTo}",
  },
  { path: "/make/:make?/:range?/:model?" },
  { path: "/type/:type?" },
  {
    path: "/special-offers",
    key: "special-offers",
    params: { searchBy: "budget", status: "special" },
  },
];

export const updateContent = data => ({
   type: UPDATE_CONTENT,
   payload: { ...data, searchUrls },
});